import { Controller } from "stimulus";
import Rails from "rails-ujs";


export default class extends Controller {


  static targets = ["qtyCounter", "qtyField", "addedNotification", "addToCartBtn", "bottomOptionsGift", "bottomOptionsCart", "giftBadge", "hiddenFieldQty", "maxQtyCounter", "userNoteInput"]

  connect() {
    const event = new CustomEvent("render-product-preview");
    window.dispatchEvent(event);
  }


  increaseQty(e) {

    console.log("increase qty");

    if (e.target.tagName == "A") {
      e.preventDefault()
    }
    var currentQty = parseInt(this.qtyCounterTarget.innerText);

    if (this.hasMaxQtyCounterTarget) {
      console.log("hasmaxqtycounter")
      console.log(this.maxQtyCounterTarget.dataset.maxQty);
      console.log("qty", currentQty);
      if (currentQty == parseInt(this.maxQtyCounterTarget.dataset.maxQty)) return;
    }
    
    this.qtyCounterTarget.innerText = currentQty+1;

    if (this.hasQtyFieldTarget) {
      this.qtyFieldTarget.value = currentQty+1;
    }
    if (this.hasHiddenFieldQtyTarget) {
      this.hiddenFieldQtyTarget.value = currentQty+1;
    }

    window.dispatchEvent(new CustomEvent("increased-product-qty"));
  }



  decreaseQty(e) {

    if (e.target.tagName == "A") {
      e.preventDefault()
    }
    
    var currentQty = parseInt(this.qtyCounterTarget.innerText);
    if (currentQty == 1) return;
    this.qtyCounterTarget.innerText = currentQty-1;

    if (this.hasQtyFieldTarget) {
      this.qtyFieldTarget.value = currentQty-1;
    }

    if (this.hasHiddenFieldQtyTarget) {
      this.hiddenFieldQtyTarget.value = currentQty-1;
    }

    window.dispatchEvent(new CustomEvent("decreased-product-qty"));
  }








  // Gifts
  increaseQtyGift(e) {
    e.preventDefault();
    var currentQty = parseInt(this.qtyCounterTarget.innerText);
    if (this.hasMaxQtyCounterTarget) {
      // if (currentQty == parseInt(this.maxQtyCounterTarget.dataset.maxQty)) return;

      if (currentQty >= parseInt(this.maxQtyCounterTarget.dataset.maxQty)) {
        this.maxQtyCounterTarget.innerText = currentQty+1;
      }
    }
    this.qtyCounterTarget.innerText = currentQty+1;

    if (this.hasQtyFieldTarget) {
      this.qtyFieldTarget.value = currentQty+1;
    }
    if (this.hasHiddenFieldQtyTarget) {
      this.hiddenFieldQtyTarget.value = currentQty+1;
    }

    var autosubmitForm = document.getElementById("autosubmitForm")
    if (autosubmitForm.length > 0) {
      autosubmitForm.submit();
    }
  }


  decreaseQtyGift(e) {
    e.preventDefault();    
    var currentQty = parseInt(this.qtyCounterTarget.innerText);
    if (currentQty == 0) return;
    this.qtyCounterTarget.innerText = currentQty-1;


    if (this.hasQtyFieldTarget) {
      this.qtyFieldTarget.value = currentQty-1;
    }

    if (this.hasHiddenFieldQtyTarget) {
      this.hiddenFieldQtyTarget.value = currentQty-1;
    }

    
    var autosubmitForm = document.getElementById("autosubmitForm")
    if (autosubmitForm.length > 0) {
      autosubmitForm.submit();
    }
  }




  notifyAdd() {

    if (this.hasUserNoteInputTarget) {
      if (this.userNoteInputTarget.value == null || this.userNoteInputTarget.value.length < 3) {
        return;
      }
    }

    // setTimeout(() => {
      
    //   this.addToCartBtnTarget.disabled = true;
    // }, 0);

    this.addedNotificationTarget.classList.remove("hidden");
    var currentQty = parseInt(this.qtyCounterTarget.innerText);

    this.addedNotificationTarget.innerText = currentQty == 1 ? "1 articolo aggiunto al carrello!" : `${currentQty} articoli aggiunti al carrello!`


 


    setTimeout(() => {
      // this.addToCartBtnTarget.disabled = false;
      this.addedNotificationTarget.classList.add("hidden");
    }, 2500);
  }


  toggleBottomOptions(e) {
    this.bottomOptionsCartTarget.classList.toggle("hidden");
    this.bottomOptionsGiftTarget.classList.toggle("hidden");

    console.log("event", e);
    
    if (this.giftBadgeTarget.dataset.giftId == undefined || this.bottomOptionsGiftTarget.classList.contains("hidden")) {
      this.element.classList.remove("elect-none", "opacity-50", "pointer-events-none");
    } else {
      this.element.classList.add("select-none", "opacity-50", "pointer-events-none");
    }
  }

  toggleGiftBadges() {

    window.selectedGifts.forEach((gift) => {
      gift.products.forEach((productId) => {
        var badge = document.querySelector(`.gift-badge[data-product-id="${productId}"]`);
        badge.classList.remove("hidden");
        badge.dataset.giftId = gift.id;
      })
    })
    
    // document.querySelectorAll(".gift-badge").forEach((b) => {
    //   if (window.selectedGifs.)
    // })
  }


  updateGiftsSelection(e) {
    var productId = this.element.dataset.productId;
  

    if (e.target.checked) {
      var input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", `selected_product_${productId}`);
      input.setAttribute("value", productId);
      input.setAttribute("data-gift", true);
      
     
      document.getElementById("confirm_gifts_selection").appendChild(input);
    } else {
      document.querySelectorAll("#confirm_gifts_selection input[type=hidden]").forEach((x) => {
        if (x.value == productId) x.remove();
      })
    }
  }

  saveSelection(e) {

    var productID = e.target.dataset.productId;
    var customProductID = e.target.dataset.customProductId;


    var isChecked = e.target.checked;

    fetch("/shop/cart/save_selection", {
      method: "post",
      credentials: "same-origin",
      headers: {
        'Accept': "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken(),
      },
      body: JSON.stringify({ product_id: productID, custom_product_id: customProductID, checked: isChecked }),
    }).then((response) => {   
     
    });
  }
  

}